import React from "react";
import { Layout, Breadcrumb } from 'antd';
import "../css/layout.css"
import Nav from "../component/Nav";
import Sidebar from "../component/Sidebar";
import Cookies from "js-cookie";
import "../css/nav.css"

const { Content, Footer} = Layout;

const LayoutComponent = (props) => { 
    return (
<div>
<Layout>
    <Nav/>
    <Layout>
    {Cookies.get('user') !== undefined ? <Sidebar/> : null}
    
      <Layout className="site-layout-background" style={{ padding: '24px 0' }}>
        
        <Content style={{ padding: '0 24px', minHeight: 580 }}>{props.content}</Content>
      </Layout>
    </Layout>
    
    <Footer className="footer" style={{ color: "white", backgroundColor:"black", textAlign: 'center' }}>Final Project ReactJS Sanbercode Bootcamp Batch 29 ©2021 Created by Dzikra Yuhasyra </Footer>
  </Layout>
  </div>
)
}



export default LayoutComponent